import { isSbConnectUser } from '@/helpers/helper';
import { useAuth } from '@/hooks';
import { Grid2 } from '@mui/material';
import { AudioStartCard } from '../AudioStartCard';
import LeftPanel from '../LeftPanel';
import PortalRightPanel from '../RightPanel/PortalRightPanel';

const PortalLayout = () => {
  const { token } = useAuth();
  const isSbConnect = isSbConnectUser(token);

  return (
    <Grid2
      container
      columnSpacing={{ xs: 0, lg: '81px' }}
      rowSpacing={{ xs: '20px', lg: 0 }}
      sx={{
        alignItems: 'stretch',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <LeftPanel isSbConnect={isSbConnect} />

      {!isSbConnect && <PortalRightPanel />}

      <Grid2 size={{ xs: 12 }} sx={{ display: { xs: 'block', lg: 'none' } }}>
        <AudioStartCard
          title="Our A.I. will generate your SOAP note"
          subtitle="You auto-paste it into your EHR"
          allowParallelRecording={isSbConnect}
        />
      </Grid2>
    </Grid2>
  );
};

export default PortalLayout;
